import api from "@/plugins/api";
import { isStubMode } from "./stub-mode";
/**
 * BFF route of the OPDOC schema-registry reads. Service-name prefixed (R32/R83
 * spirit: "registry" alone is ambiguous at the BFF level).
 */
const BASE_PATH = "opdoc-registry";
function delay(value, ms = 200) {
    return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}
/** Minimal stub mirroring the seeded OPDOC registry so local dev renders the dropdowns. */
const MOCK_CONTEXTS = [
    {
        key: "don",
        labelKey: "registry.context.don",
        label: "Don",
        documentTypes: [
            { key: "recu-fiscal", labelKey: "registry.documentType.recuFiscal", label: "Reçu fiscal" },
        ],
    },
    {
        key: "contact",
        labelKey: "registry.context.contact",
        label: "Contact",
        documentTypes: [
            { key: "courrier", labelKey: "registry.documentType.courrier", label: "Courrier" },
        ],
    },
];
/**
 * API client for the OPDOC schema-registry reads. Labels come resolved for the
 * caller's UI language (OPDOC reads the `locale` JWT claim).
 */
export const registryApi = {
    async getContexts() {
        if (isStubMode()) {
            return delay(MOCK_CONTEXTS.map((c) => ({ ...c, documentTypes: [...c.documentTypes] })));
        }
        const response = await api.get(`${BASE_PATH}/contexts`, {
            unwrapEnvelope: true,
        });
        return response.data;
    },
};
